import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col">
      <Header />
      <main data-testid="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
